/* eslint-disable react/jsx-no-duplicate-props */
// Material-ui > inputProps: Attributes applied to the native input element
// Material-ui > InputProps: Properties applied to the Input element.

import React from "react";
import { inputs, results } from "../data";
import {
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Card,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { VictoryChart, VictoryBar, VictoryAxis, VictoryTheme } from "victory";

let settings = {
  inputProperties: {
    min: "0",
    step: "1"
  }
};

export class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      region: "au",
      pole_quantity: "",
      access_cost: "",
      electrian_cost: "",
      maintenance_cycle: "",
      prices: {
        us: { hg: 250, al: 335 },
        ca: { hg: 300, al: 370 },
        au: { hg: 275 }
      },
      finish: ""
    };
    this.onChange = this.onChange.bind(this);
  }
  onChange(key, event) {
    let value;
    if (key === "finish") {
      // string
      value = event.target.value;
    } else {
      // number
      value = parseFloat(event.target.value);
    }
    this.setState({ [key]: value ? value : "" });
    localStorage.setItem(key, value);
  }

  // Baseline
  calculateTotalMaintenanceCost(pole_quantity, access_cost, electrian_cost) {
    return pole_quantity * (access_cost + electrian_cost);
  }
  // Investment
  calculateInstallCost(pole_quantity, electrian_cost, unit_cost) {
    return pole_quantity * (unit_cost + electrian_cost);
  }
  // Maintenance Cost
  calculatessjMaintenanceCost(pole_quantity, electrian_cost) {
    return pole_quantity * (electrian_cost / 2);
  }

  // One Time Saving
  calculateTotalOneTimeSaving(maintenance_cost, ssj_install_cost) {
    return maintenance_cost - ssj_install_cost;
  }

  calculateTotalSavingByYear(years, maintenance_cost, ssjMaintenanceCost, maintenance_cycle, ssj_install_cost) {
    if (maintenance_cycle > 0) {
      let current_cost = (years / maintenance_cycle) * maintenance_cost;
      let ssj_cost = (years / maintenance_cycle - 1) * ssjMaintenanceCost + ssj_install_cost;
      return Math.round(current_cost - ssj_cost);
    }
    return 0;
  }

  createChartData(maintenance_cycle, years, maintenance_cost) {
    let cycles = Math.round(years / maintenance_cycle);
    let chartData = [];
    for (let i = 1; i <= cycles; i++) {
      chartData.push({ cycle: i, cost: i * maintenance_cost });
    }
    return chartData;
  }

  componentDidMount() {
    // currently au only has hg option (reset local storage in case 'al' has been stored from us/ca calcutlator)
    if (this.props.region === "au") {
      localStorage.setItem("finish", "hg");
    } else if (!localStorage.getItem("finish")) {
      localStorage.setItem("finish", "hg");
    }
    this.setState({
      region: this.props.region,
      pole_quantity: parseFloat(localStorage.getItem("pole_quantity")) || 500,
      access_cost: parseFloat(localStorage.getItem("access_cost")) || 1200,
      electrian_cost: parseFloat(localStorage.getItem("electrian_cost")) || 120,
      maintenance_cycle: parseFloat(localStorage.getItem("maintenance_cycle")) || 2,
      finish: localStorage.getItem("finish")
    });
  }

  render() {
    let { region, pole_quantity, access_cost, electrian_cost, prices, maintenance_cycle, finish } = this.state;
    let unit_cost = prices[region][finish];

    let maintenance_cost = this.calculateTotalMaintenanceCost(pole_quantity, access_cost, electrian_cost);

    let ssj_install_cost = this.calculateInstallCost(pole_quantity, electrian_cost, unit_cost);

    let ssjMaintenanceCost = this.calculatessjMaintenanceCost(pole_quantity, electrian_cost);

    let totalOneTimeSaving = this.calculateTotalOneTimeSaving(maintenance_cost, ssj_install_cost);

    let totalSavingByYear = this.calculateTotalSavingByYear(
      25,
      maintenance_cost,
      ssjMaintenanceCost,
      maintenance_cycle,
      ssj_install_cost
    );

    let cycleLabel = maintenance_cycle > 0 ? `/ ${maintenance_cycle} yrs` : "";

    return (
      <div className="Calculator">
        <Grid className="row-1" container spacing={24}>
          <Grid item xs={3}>
            <Card>
              <div className="p-3 bg-primary color-text-white text-bold">
                Project Data
              </div>
              <div className="p-3">
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <TextField
                      label={inputs[0].label}
                      type="number"
                      inputProps={settings.inputProperties}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">QTY</InputAdornment>
                      }}
                      fullWidth={true}
                      value={this.state[inputs[0].name]}
                      onChange={event => this.onChange(inputs[0].name, event)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={inputs[1].label}
                      type="number"
                      inputProps={settings.inputProperties}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                      }}
                      fullWidth={true}
                      value={this.state[inputs[1].name]}
                      onChange={event => this.onChange(inputs[1].name, event)}
                    />
                    <Typography className="pt-2" style={{ fontSize: "12px", color: grey[600] }}>Per non-lowering pole<br/>(scaffold, EWP, etc)</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={inputs[2].label}
                      type="number"
                      inputProps={settings.inputProperties}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                      }}
                      fullWidth={true}
                      value={this.state[inputs[2].name]}
                      onChange={event => this.onChange(inputs[2].name, event)}
                    />
                    <Typography className="pt-2" style={{ fontSize: "12px", color: grey[600] }}>Approx 2 x 0.5h</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={inputs[3].label}
                      type="number"
                      inputProps={settings.inputProperties}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">YRS</InputAdornment>
                      }}
                      fullWidth={true}
                      value={this.state[inputs[3].name]}
                      onChange={event => this.onChange(inputs[3].name, event)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="finish">
                      <Typography style={{ fontSize: "12px", color: grey[600] }}>Finish</Typography>
                    </InputLabel>
                    <Select
                      onChange={event => this.onChange("finish", event)}
                      value={finish}
                      fullWidth={true}
                      inputProps={{
                        name: "finish",
                        id: "finish"
                      }}>
                      <MenuItem value="hg">{region === "us" || region === "ca" ? "Hot-dip Galvanized" : "Hot-dip Galvanised"}</MenuItem>
                      {region === "us" || region === "ca" ? <MenuItem value="al">Aluminum</MenuItem> : null}
                    </Select>
                  </Grid>
                </Grid>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card style={{height: "100%"}}>
                <div className="p-3 bg-primary color-text-white text-bold text-center">
                  Maintenance cost over 25 years
                </div>
                <VictoryChart theme={VictoryTheme.grayscale} domainPadding={70} width={350} height={400}>
                  <VictoryAxis
                    tickValues={["Current Cost", "With Swivelpole™"]}
                    style={{ tickLabels: { fontSize: "11px" } }}
                  />
                  {maintenance_cycle && maintenance_cost && ssjMaintenanceCost ? (
                    <VictoryBar
                      alignment="middle"
                      barWidth={50}
                      cornerRadius={1}
                      style={{
                        data: { fill: d => (d.x === 2 ? "#FF6600" : "#CCC") },
                        labels: {
                          fill: d => (d.x === 2 ? "#FF6600" : "black")
                        }
                      }}
                      data={[
                        {
                          x: 1,
                          y: Math.round(maintenance_cost * (25 / maintenance_cycle))
                        },
                        {
                          x: 2,
                          y: Math.round(maintenance_cost * (25 / maintenance_cycle) - totalSavingByYear)
                        }
                      ]}
                      labels={d => `$ ${d.y.toLocaleString()}`}
                    />
                  ) : null}
                </VictoryChart>
            </Card>
          </Grid>
          <Grid item xs={3}>
            <Card>
              <div className="p-3 bg-primary color-text-white text-bold">
                Results
              </div>
              <div className="p-3" style={{height: "100%"}}>
                <Typography inline={true} variant="h6">
                  $ {maintenance_cost.toLocaleString()} <Typography inline={true}>{cycleLabel}</Typography>
                </Typography>
                <Typography variant="body2" style={{ fontSize: "12px", color: grey[600] }}>
                  {results[0].label}
                </Typography>
                <hr />
                <Typography inline={true} variant="h6">
                  $ {ssj_install_cost.toLocaleString()}
                </Typography>
                <Typography variant="body2" style={{ fontSize: "12px", color: grey[600] }}>
                  {results[1].label}
                </Typography>
                <hr />
                <Typography inline={true} variant="h6">
                  $ {ssjMaintenanceCost.toLocaleString()} <Typography inline={true}>{cycleLabel}</Typography>
                </Typography>
                <Typography variant="body2" style={{ fontSize: "12px", color: grey[600] }}>
                  {results[2].label}
                </Typography>
                <hr />
                <Typography inline={true} variant="h6">
                  $ {totalOneTimeSaving.toLocaleString()}
                </Typography>
                <Typography variant="body2" style={{ fontSize: "12px", color: grey[600] }}>
                  Total estimated one time saving from installing the SSJ
                </Typography>
                <hr />
                <Typography inline={true} variant="h6">
                  $ {totalSavingByYear.toLocaleString()}
                </Typography>
                <Typography variant="body2" style={{ fontSize: "12px", color: grey[600] }}>
                  {results[4].label}
                </Typography>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default Calculator;
